import React, { useEffect, useState } from "react";
import logo from "../images/logo.png";
import { useTranslation } from "react-i18next";

const ComingSoon = () => {
  const [countdown, setCountdown] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const targetDate = new Date("2025-01-15T23:59:59").getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) {
        setCountdown(t('Coming_Soon'));
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setCountdown(`${days}${t('dd')} ${hours}${t('hh')} ${minutes}${t('mm')} ${seconds}${t('ss')} `);
    };

    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [t]);

  return (
    <>
      {/* Mobile   */}
      <div className="md:hidden">
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-500 to-teal-500 text-white">
          <div className="text-center px-6">
            <div className="mb-4">
              <img src={logo} alt="Escort logo" />
            </div>

            <h1 className="text-4xl md:text-6xl font-bold mb-4">{t('Coming_Soon')}</h1>
            <p className="text-lg md:text-xl my-10">
            {t('working_hard')}
            </p>
            <p className="text-3xl font-bold mt-10">
            {t('remaining_time')}
            </p>
            <div className="text-xl font-semibold mb-6 mt-5">{countdown}</div>
            {/* <div className="flex justify-center space-x-4">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl hover:text-yellow-400 transition"
          >
            🌐
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl hover:text-yellow-400 transition"
          >
            🐦
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl hover:text-yellow-400 transition"
          >
            📷
          </a>
        </div> */}
          </div>
        </div>
      </div>
      {/* Desktop   */}
      <div className="hidden md:block">
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-500 to-teal-500 text-white">
          <div className="mb-4">
            <img src={logo} alt="Escort logo" />
          </div>
          <div className="text-center px-6">

            <h1 className="text-4xl md:text-6xl font-bold mb-4">{t('Coming_Soon')}</h1>
            <p className="text-lg md:text-xl my-10">
              {t('working_hard')}
            </p>
            <p className="text-3xl font-bold mt-10">
              {t('remaining_time')}
            </p>
            <div className="text-xl font-semibold mb-6 mt-5">{countdown}</div>
            {/* <div className="flex justify-center space-x-4">
          <a
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl hover:text-yellow-400 transition"
          >
            🌐
          </a>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl hover:text-yellow-400 transition"
          >
            🐦
          </a>
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-2xl hover:text-yellow-400 transition"
          >
            📷
          </a>
        </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;
